export const FETCH_CUSTOMERS_INIT = 'REGISTERS::FETCH_CUSTOMERS_INIT';
export const FETCH_CUSTOMERS_SUCCESS = 'REGISTERS::FETCH_CUSTOMERS_SUCCESS';
export const FETCH_CUSTOMERS_ERROR = 'REGISTERS::FETCH_CUSTOMERS_ERROR';
export const SET_STATE = 'REGISTERS::SET_STATE';
